import { useChatSettingsStore } from "~/shared/store/useChatSettingsStore";

/**
 * Значения настроек и их сеттеры из стора — двадцать селекторов, вынесенные из
 * формы. Селектор на поле (а не один на весь стор) оставлен намеренно: так
 * перерисовка приходит только тому, чьё поле изменилось.
 */
export function useChatSettingsState() {
    const artifactType = useChatSettingsStore((s) => s.artifactType);
    const modelId = useChatSettingsStore((s) => s.modelId);
    const mode = useChatSettingsStore((s) => s.mode);
    const aspectRatio = useChatSettingsStore((s) => s.aspectRatio);
    const resolution = useChatSettingsStore((s) => s.resolution);
    const duration = useChatSettingsStore((s) => s.duration);
    const audioEnabled = useChatSettingsStore((s) => s.audioEnabled);
    const characterOrientation = useChatSettingsStore((s) => s.characterOrientation);
    const upscaleFactor = useChatSettingsStore((s) => s.upscaleFactor);
    const batchSize = useChatSettingsStore((s) => s.batchSize);
    const setArtifactType = useChatSettingsStore((s) => s.setArtifactType);
    const setModelId = useChatSettingsStore((s) => s.setModelId);
    const setMode = useChatSettingsStore((s) => s.setMode);
    const setAspectRatio = useChatSettingsStore((s) => s.setAspectRatio);
    const setResolution = useChatSettingsStore((s) => s.setResolution);
    const setDuration = useChatSettingsStore((s) => s.setDuration);
    const setAudioEnabled = useChatSettingsStore((s) => s.setAudioEnabled);
    const setCharacterOrientation = useChatSettingsStore((s) => s.setCharacterOrientation);
    const setUpscaleFactor = useChatSettingsStore((s) => s.setUpscaleFactor);
    const setBatchSize = useChatSettingsStore((s) => s.setBatchSize);

    return {
        artifactType,
        modelId,
        mode,
        aspectRatio,
        resolution,
        duration,
        audioEnabled,
        characterOrientation,
        upscaleFactor,
        batchSize,
        setArtifactType,
        setModelId,
        setMode,
        setAspectRatio,
        setResolution,
        setDuration,
        setAudioEnabled,
        setCharacterOrientation,
        setUpscaleFactor,
        setBatchSize,
    };
}

export type ChatSettingsState = ReturnType<typeof useChatSettingsState>;
